import _ from 'lodash';
import qs from 'querystring';
import moment from 'moment';
import errorReporter from '@app/errorReporter';
import {
  formatActionTaken,
  formatPhoneNumber,
  formatNonAgentStatus,
  MAX_NOTICE_IN_MINUTES,
  correctShowingTypeLabel,
  featureEnabled,
} from 'utils';
import { parseLabelFromString } from 'contexts';
import template from './appointment_action.html';
import { HOME_INSPECTION_TYPES } from '../constants';

angular.module('bb.appointments').component('bbAppointmentAction', {
  bindings: {},
  controller: AppointmentActionCtrl,
  controllerAs: 'vm',
  template,
});

AppointmentActionCtrl.$inject = [
  '$scope',
  '$resource',
  '$location',
  '$route',
  '$rootScope',
  '$routeParams',
  'loadContacts',
  'showStatus',
  'AppointmentBookService',
  'ModalService',
  'ToastService',
  'ErrorService',
  '$q',
];

function AppointmentActionCtrl(
  $scope,
  $resource,
  $location,
  $route,
  $rootScope,
  $routeParams,
  loadContacts,
  showStatus,
  AppointmentBookService,
  ModalService,
  ToastService,
  ErrorService,
  $q,
) {
  // TODO: Leaving these to be Axios calls when migrated to REACT
  const Appointment = $resource('/appointments/:appointmentId', {
    appointmentId: '@appointmentId',
  });
  const AppointmentConfig = $resource('/appointments/:appointmentId/config', {
    appointmentId: '@appointmentId',
  });
  const ListingAppointmentConfig = $resource(
    '/listing/:listingId/appointments/config',
    { listingId: '@listingId' },
  );
  const AppointmentCoopUpdate = $resource('/appointment/:appointmentId/coop', {
    appointmentId: '@appointmentId',
  });
  const AppointmentResendNotifications = $resource(
    '/appointment/:appointmentId/resend',
    { appointmentId: '@appointmentId' },
  );
  const AppointmentNote = $resource('/appointment/:appointmentId/note', {
    appointmentId: '@appointmentId',
  });
  const AppointmentOverrideStatus = $resource(
    '/appointments/:appointmentId/new',
    { appointmentId: '@appointmentId' },
  );
  const GenerateCode = $resource('/appointment/:appointmentId/dynamiccode', {
    appointmentId: '@appointmentId',
  });
  const OfferCount = $resource('/listing/:listingId/offer_count', {
    listingId: '@listingId',
  });

  const ShowingType = $resource(
    '/appointments/:appointmentId/showingType/:showingType',
    {
      appointmentId: '@appointmentId',
      showingType: '@showingType',
    },
  );

  const Status = $resource('/appointments/:appointmentId/:status', {
    appointmentId: '@appointmentId',
    status: '@status',
  });
  const vm = this;
  vm.auth = $rootScope.auth;
  vm.viewDashAppointment = $rootScope.viewDashAppointment;
  vm.isCovidFlagEnabled = $rootScope.hasFeature('COVID_19');

  vm.openContactDrawer = $rootScope.openContactDrawer;

  vm.homeInspectionTypes = HOME_INSPECTION_TYPES;

  vm.nonAgentTypes = [
    'Home Inspection',
    'Appraisal',
    'Photographer',
    'Pest Control',
  ];
  vm.nonAgentLabel = {
    'Home Inspection': 'Home Inspector',
    Appraisal: 'Appraiser',
    Photographer: 'Photographer',
    'Pest Control': 'Pest Control',
  };

  vm.showingTypes = [
    'Buyer/Broker',
    'Revisit',
    ...HOME_INSPECTION_TYPES,
    'Agent Inspection',
    ...(featureEnabled('transactionBrokerTypeFeature')
      ? ['Transaction Broker']
      : []),
    ...vm.nonAgentTypes,
    'Dual Agency',
    'Buyer Visit',
    'Information Request',
    'Final Walkthrough',
  ];
  vm.redHighlightTypes = [
    ...HOME_INSPECTION_TYPES,
    'Buyer Visit',
    ...vm.nonAgentTypes,
  ];
  vm.overridenNotify = {
    email: false,
    text: false,
    office: true,
  };

  vm.canEdit = false;

  vm.updateInProgress = false;

  vm.formatNonAgentStatus = formatNonAgentStatus;

  vm.formatActionTaken = ({
    status,
    originalTime,
    actionTaken,
    isPending,
    nonAgentNotified,
    date,
    auditEntry,
  }) => {
    return formatActionTaken(
      {
        status,
        date,
        originalTime,
        actionTaken,
        isPending,
        nonAgentNotified,
        auditEntry,
      },
      vm.appointment.type,
      vm.appointment.coop,
      vm.mustCallContacts,
      vm.appointment.history,
    );
  };

  vm.formatPhoneNumber = formatPhoneNumber;
  vm.correctShowingTypeLabel = correctShowingTypeLabel;

  vm.selectShowingType = ($event, type) => {
    $event.stopPropagation();
    $event.preventDefault();
    vm.selectedShowingType = type;
  };

  vm.hasNonAgentNotificationFeature = featureEnabled(
    'nonAgentNotificationFeature',
  );
  vm.hasTransactionBrokerTypeFeature = featureEnabled(
    'transactionBrokerTypeFeature',
  );

  vm.updateShowingType = $event => {
    $event.stopPropagation();
    $event.preventDefault();
    vm.updateInProgress = true;
    const totalNoticeInMinutes =
      (vm.appointmentConfig.notice || 0) * 60 +
      (vm.appointmentConfig.noticeMinutes || 0);
    // 100hr -> mins
    const noticeCheck =
      totalNoticeInMinutes >= MAX_NOTICE_IN_MINUTES ||
      vm.appointmentConfig.notice < 0 ||
      vm.appointmentConfig.noticeMinutes > 60;
    if (noticeCheck) {
      vm.isInvalidNotice = true;
      vm.dataLoaded = true;
      return;
    }

    const showingType = new ShowingType({
      appointmentId: $routeParams.appointmentId,
      showingType: vm.selectedShowingType,
    });

    showingType.$save(
      () => {
        vm.updateInProgress = false;
        vm.appointment.type = vm.selectedShowingType;
        $('#appointmentTypeDropdown').removeClass('open');
        $('#appointmentTypeToggle').attr('aria-expanded', 'false');
      },
      err => {
        vm.updateInProgress = false;
        ToastService.add({
          type: 'warning',
          message: `ERROR: Showing Type was not updated: ${err.data.message}`,
        });
      },
    );
  };

  vm.action = {
    tab: 'contacts',
    restrictions: 'weekly',
    taken: '',
    cancelled_by: 'seller',
  };

  vm.accessMap = {
    lockbox: 'Lock Box',
    key: 'Key',
    doorcode: 'Door Code',
    direct: 'Direct',
    sentrilockapp: 'SentriLock App',
    masterlock: 'MasterLock',
  };

  vm.instructionsMap = {
    lights: 'Turn Off Lights',
    shoes: 'Remove Shoes',
    card: 'Leave Card',
    lock_doors: 'Lock Doors',
    knockFirst: 'Knock First',
    callIfLate: 'Call if Late or Cancelling',
    reco: 'Bring Agent License',
  };

  vm.getMultiConfIndex = ({ contactId }) => {
    const multiConfContacts = vm.appointmentConfig.contacts
      .filter(contact => contact.mustConfirm)
      .map(contact => contact.contactId);
    return `(${multiConfContacts.indexOf(contactId) + 1} of ${
      multiConfContacts.length
    })`;
  };

  vm.showTab = tabId =>
    showStatus(vm.appointment.status, tabId) && vm.action.type !== 'removed';

  vm.getConfirmationInstructions = ({ access, instructions }) => ({
    access,
    instructions,
  });

  vm.viewPreviousAppointmentConfig = false;

  vm.toggleAppointmentConfigView = () => {
    vm.viewPreviousAppointmentConfig = !vm.viewPreviousAppointmentConfig;
  };

  vm.setCanEdit = () => {
    if (vm.appointment) {
      const { isPending, status, timeEnd } = vm.appointment;
      // All Statuses
      // 'cancel' | 'confirm' | 'new' | 'deny' | 'time_change' | 'attempted' | 'removed' | 'time_passed';
      const editableStatuses = ['new', 'New', 'time_change', 'attempted'];
      if (editableStatuses.includes(status)) {
        vm.canEdit = true;
        return;
      }
      if (status === 'confirm') {
        const today = moment();
        if (isPending || today.isBefore(moment(timeEnd))) {
          vm.canEdit = true;
        }
      }
    } else {
      errorReporter.error('Showing is not set yet, look at init.');
    }
  };

  vm.getTimeChangeRequester = () => {
    if (
      vm.appointment.status === 'time_passed' &&
      vm.appointment.listingContactTimeChange
    ) {
      return (
        _.findLast(vm.appointment.history, history =>
          ['suggested_time_change', 'time_change'].includes(history.status),
        )?.userType || 'LISTING CONTACT'
      );
    }
    return '';
  };

  const init = () => {
    // ENG-12470 This logic was moved from listing_view.component.js
    const searchQuery = $location.absUrl().split('?')[1];
    // NonAgent Notification Approval Logic is also stored in query
    const { nonAgentApprovalHash: approvalHash, ...queryObj } =
      qs.parse(searchQuery);
    if (approvalHash) {
      $location.search(queryObj);
      AppointmentBookService.approveNonAgentForAppointment(approvalHash)
        .then(({ isCustomAgent, approvedBefore, type }) => {
          const contactNameMap = {
            Photographer: 'photographer',
            'Pest Control': 'pest control',
            Appraisal: 'appraiser',
            'Home Inspection': 'home inspector',
          };
          swal(
            approvedBefore
              ? 'This Contact Has Already Been Approved'
              : 'Contact Approved',
            approvedBefore
              ? 'This Contact has already been added and no further action is required.'
              : `This ${
                  isCustomAgent
                    ? 'non-agent'
                    : contactNameMap[type] || 'home inspector / appraiser'
                } contact has been approved for the appointment.`,
            'success',
          );
        })
        .catch(ErrorService.toastyHTTPErr);
    }

    Appointment.get({ appointmentId: $routeParams.appointmentId })
      .$promise.then(data => {
        vm.appointment = data.appointment;
        vm.selectedShowingType = vm.appointment.type;
        vm.listing = data.listing;

        vm.timeChangeRequester = vm.getTimeChangeRequester();
        vm.mlsTypes = data.listing.org?.mlsTypes.length
          ? data.listing.org.mlsTypes
          : null;

        // determine first tab
        if (
          vm.appointment.status === 'confirm' ||
          vm.appointment.status === 'time_passed'
        ) {
          vm.action.type = 'cancel';
        } else {
          vm.action.type = null;
        }

        vm.listingLink = `#/listing/${vm.listing.id}/view`;

        $q.all([
          ListingAppointmentConfig.get({
            listingId: vm.listing.id,
          }).$promise,
          OfferCount.get({ listingId: vm.listing.id }).$promise,
        ])
          .then(([appointmentConfig, { count }]) => {
            const agentIds = appointmentConfig.contacts
              .filter(contact => contact.type === 'Agent')
              .map(contact => contact.contactId);

            return loadContacts(
              $resource,
              vm,
              $q,
              vm.listing.id,
              agentIds,
            ).then(() => {
              vm.appointmentConfig = appointmentConfig;
              if (vm.appointment.appointmentConfig) {
                vm.appointmentConfig = {
                  ...vm.appointmentConfig,
                  ...vm.appointment.appointmentConfig,
                };
              }
              if (vm.appointment.previousAppointmentConfig) {
                vm.previousAppointmentConfig = vm.getConfirmationInstructions(
                  vm.appointment.previousAppointmentConfig,
                );
              }
              vm.offerCount = count;
              vm.contactsToMustCall = appointmentConfig.contacts.reduce(
                (contacts, contact) => {
                  if (contact.type === 'Concierge') return contacts;
                  const rep = vm.repsById[contact.contactId];
                  if (
                    rep &&
                    Array.isArray(rep.phone) &&
                    rep.phone.some(({ mustCall }) => mustCall)
                  ) {
                    contacts.push(rep);
                  }
                  return contacts;
                },
                [],
              );
              vm.mustCallContacts = vm.contactsToMustCall.length > 0;
              vm.multiConfContacts =
                vm.appointment.multiConf &&
                vm.appointment.multiConf
                  .map(({ id, status }) => ({
                    ...vm.repsById[id],
                    status,
                  }))
                  .sort(
                    (a, b) =>
                      (a.status === 'confirm') - (b.status === 'confirm'),
                  );

              vm.contactId =
                vm.multiConfContacts &&
                vm.multiConfContacts[0] &&
                vm.multiConfContacts[0].status !== 'confirm'
                  ? vm.multiConfContacts[0].contactId
                  : undefined;

              vm.setCanEdit();
              vm.isPendingMultiConf = vm.appointment?.multiConf?.some(
                contact => contact.status !== 'confirm',
              );
            });
          })
          .catch(errorReporter.error)
          .finally(() => {
            vm.dataLoaded = true;
          });
      })
      .catch(errorReporter.error);
  };

  vm.$onDestroy = () => {
    swal.close();
  };

  vm.$onInit = () => {
    init();
    AppointmentBookService.queryAppointmentEmailDelivery(
      $routeParams.appointmentId,
    )
      .then(data => {
        vm.emailDeliveryLog = data;
      })
      .catch(errorReporter.error);

    AppointmentBookService.queryAppointmentTextDelivery(
      $routeParams.appointmentId,
    )
      .then(data => {
        vm.textDeliveryLog = data;
      })
      .catch(errorReporter.error);

    AppointmentBookService.queryAppointmentPushNotificationDelivery(
      $routeParams.appointmentId,
    )
      .then(data => {
        vm.pushNotificationDeliveryLog = data;
      })
      .catch(errorReporter.error);
  };

  vm.selectSpecialDay = day => {
    vm.restrictDate = day;
  };

  // TODO: This is making more check sentrilock route
  vm.showEditConfig = () => {
    vm.tempPreviousAppointmentConfig = vm.getConfirmationInstructions(
      _.cloneDeep(vm.appointmentConfig),
    );
    vm.tempAppointmentConfig = _.cloneDeep(vm.appointmentConfig);
    ModalService.openAppointmentConfigModal(
      vm.appointment,
      vm.tempAppointmentConfig,
      () => {
        vm.previousAppointmentConfig = vm.tempPreviousAppointmentConfig;
        vm.appointmentConfig = vm.tempAppointmentConfig;
      },
    );
  };

  vm.hasListingContact = contact =>
    Object.keys(vm.listingContacts || {}).includes(
      contact.id || contact.contactId,
    );

  vm.hideEditConfig = () => {
    ModalService.closeAppointmentConfigModal();
  };

  vm.saveConfig = () => {
    vm.dataLoaded = false;
    const totalNoticeInMinutes =
      (vm.appointmentConfig.notice || 0) * 60 +
      (vm.appointmentConfig.noticeMinutes || 0);
    // 100hr -> mins
    const noticeCheck =
      totalNoticeInMinutes >= MAX_NOTICE_IN_MINUTES ||
      vm.appointmentConfig.notice < 0 ||
      vm.appointmentConfig.noticeMinutes > 60;
    if (noticeCheck) {
      vm.isInvalidNotice = true;
      ToastService.add({
        type: 'warning',
        message: 'Showing Notice is Invalid.',
      });
      vm.dataLoaded = true;
      return;
    }

    const partialAppointmentConfig = vm.getConfirmationInstructions(
      vm.appointmentConfig,
    );

    const appointmentConfig = new AppointmentConfig({
      appointmentId: $routeParams.appointmentId,
      config: partialAppointmentConfig,
    });
    appointmentConfig.$save(() => {
      vm.hideEditConfig();
      vm.previousAppointmentConfig = angular.copy(vm.tempAppointmentConfig);
      vm.dataLoaded = true;
    });
  };

  vm.editCoop = () => {
    vm.customContact = _.cloneDeep(vm.appointment.coop);
    delete vm.customContact.uid;
    delete vm.customContact.id;

    vm.savingAgentInfo = false;

    $('#coopModal').modal('toggle');
  };

  vm.saveCoopIfValid = form => {
    form.$submitted = true;
    if (form.$invalid) return;
    vm.saveCoop();
  };

  vm.saveCoop = () => {
    vm.savingAgentInfo = true;

    const appointmentCoopUpdate = new AppointmentCoopUpdate({
      appointmentId: $routeParams.appointmentId,
      coop: vm.customContact,
    });

    appointmentCoopUpdate.$save(() => {
      vm.appointment.coop = vm.customContact;
      $('#coopModal').modal('toggle');
    });
  };

  vm.showResendNotificationModal = () => {
    vm.resendingNotifications = false;
    vm.resendUsers = [];
    $('#resendNotificationModal').modal('toggle');
  };

  vm.resendNotification = () => {
    const selectedUsers = [];

    vm.resendingNotifications = true;

    Object.keys(vm.resendUsers).forEach(key => {
      const selected = vm.resendUsers[key];
      if (selected) {
        selectedUsers.push(key);
      }
    });

    const resendNotifications = new AppointmentResendNotifications({
      appointmentId: $routeParams.appointmentId,
      resendUsers: selectedUsers,
    });

    resendNotifications.$save(() => {
      $('#resendNotificationModal').modal('toggle');
      swal('Showing notification sent successfully', '', 'success');
    });
  };

  vm.setContact = id => {
    vm.contactId = id;
    $scope.$apply();
  };

  vm.submit = () => {
    if (!vm.action.type || !vm.action.taken) return;
    vm.dataLoaded = false;
    const statusObj = {
      actionTaken: vm.action.taken,
      appointmentId: $routeParams.appointmentId,
      status: vm.action.type,
      contactId: vm.contactId,
    };

    if (vm.action.type === 'cancel') {
      statusObj.actionDetails = {
        cancelledBy: vm.action.cancelled_by,
      };
    }

    const status = new Status(statusObj);

    status.$save(() => {
      if (vm.appointment.multiConf) {
        if (
          vm.action.type === 'attempted' ||
          (vm.action.type === 'confirm' &&
            vm.appointment.multiConf.some(
              contact =>
                contact.status !== 'confirm' && contact.id !== vm.contactId,
            ))
        ) {
          $route.reload();
          return;
        }
      }

      $rootScope.viewNextAppointmentPage(
        $routeParams.appointmentId,
        vm.action.type !== 'attempted' && vm.action.type !== 'removed',
        vm.action.type,
        vm.listing.id,
      );
    });
  };

  vm.addNotes = () => {
    vm.dataLoaded = false;
    const appointmentNote = new AppointmentNote({
      note: vm.action.taken,
      appointmentId: $routeParams.appointmentId,
    });

    appointmentNote.$save(() => {
      const path =
        vm.auth.org.type === 'brokerage'
          ? '/admin/dashboard'
          : '/answering/queue';
      $location.path(path);
    });
  };

  vm.getPlaceHolder = () => {
    if (vm.action.type === 'removed') {
      return 'Why are you removing this showing from the queue without taking action?';
    }
    if (vm.action.type !== 'notes') {
      return 'What action(s) did you take to service this showing request?';
    }
    if (vm.action.type === 'notes') {
      return 'What notes did you want to add to this showing request?';
    }
    return '';
  };

  vm.getStatusText = (legacyStatus, customContact) => {
    if (
      legacyStatus ===
      'CONFIRMED: CALL CONCIERGE: MUST DELIVER TO CONCIERGE: Auto Confirmed'
    ) {
      return 'CONFIRMED: CALL AND DELIVER TO CONCIERGE';
    }

    if (
      featureEnabled('nonAgentNotificationFeature') &&
      (vm.appointment.coop.nonAgentId || vm.appointment.coop.customAgentId)
    ) {
      const {
        coop: { approvedNonAgent },
        type,
      } = vm.appointment;
      const nonAgentStatusMap = {
        deny: 'DENIED',
        cancel: 'CANCEL',
        confirm: 'CONFIRM',
      };
      const naTypeMap = {
        'Pest Control': 'PEST CONTROL',
        Photographer: 'PHOTOGRAPHER',
      };
      let naName = naTypeMap[type] || 'HOME INSPECTOR/APPRAISER';
      if (!vm.appointment.coop.isNotAgent) {
        naName = 'CUSTOM AGENT';
      }
      const approvedText = `(${naName} NOTIFIED)`;
      const notApprovedText = `(${naName} NOT NOTIFIED)`;

      if (Object.keys(nonAgentStatusMap).includes(vm.appointment.status)) {
        return `${nonAgentStatusMap[vm.appointment.status]} ${
          approvedNonAgent ? approvedText : notApprovedText
        }`;
      }
    }

    if (
      customContact &&
      legacyStatus?.toUpperCase().includes('SEND CONF: CALL') &&
      legacyStatus?.toUpperCase().includes('OFFICE: AUTO CONFIRMED')
    ) {
      return legacyStatus
        .toUpperCase()
        .replace(': AUTO CONFIRMED', '')
        .replace('SEND CONF', 'AUTO-CONFIRMED');
    }

    return legacyStatus;
  };

  vm.isAppointmentPending = () =>
    vm.appointment.isPending !== false ||
    vm.appointment.status === 'new' ||
    vm.appointment.status === 'time_change' ||
    vm.appointment.status === 'attempted' ||
    vm.appointment.status === 'time_passed';

  vm.canOverrideStatus = () =>
    vm.appointment.status !== 'new' &&
    vm.appointment.status !== 'removed' &&
    !vm.appointment.passed;

  vm.canShowAdminNote = () => true;
  vm.canRemoveFromQueue = () => vm.isAppointmentPending();
  vm.areActionsAvailable = () =>
    vm.canOverrideStatus() || vm.canShowAdminNote() || vm.canRemoveFromQueue();

  vm.showGenerateCodeModal = () => {
    vm.generatingCode = false;
    vm.newDynamicLockBoxCode = null;
    $('#generateCodeModal').modal('toggle');
  };
  vm.generateCode = () => {
    vm.generatingCode = true;
    const generateCode = new GenerateCode({
      appointmentId: $routeParams.appointmentId,
      lbsn: vm.appointmentConfig?.instructions?.sentrilock?.lbsn,
      access: vm.appointmentConfig?.access,
    });

    generateCode.$save(data => {
      vm.newDynamicLockBoxCode = data.code;
      vm.appointment.dynamicLockBoxCode = data.code;
      vm.generatingCode = false;
    });
  };

  vm.withinSentriLockDate = () => {
    if (
      vm.appointmentConfig &&
      (vm.appointmentConfig.access === 'SentriLock' ||
        (vm.appointmentConfig.access === 'SentriLockV2' &&
          vm.appointmentConfig.instructions.sentrilockv2.isOneDayCodeEnabled))
    ) {
      return (
        moment(vm.appointment.time) < moment().add(14, 'days').endOf('day')
      );
    }
    return true;
  };

  vm.resendCode = () => {
    vm.sendingCode = true;
    const coopId = vm.appointment.coop.id || vm.appointment.coop.uid;

    const resendNotifications = new AppointmentResendNotifications({
      appointmentId: $routeParams.appointmentId,
      resendUsers: [`coop-${coopId}`],
    });

    resendNotifications.$save(() => {
      vm.sendingCode = false;
      $('#generateCodeModal').modal('toggle');
      swal('Code resent successfully', '', 'success');
    });
  };

  vm.overrideStatus = () => {
    swal(
      {
        title: 'OVERRIDE SHOWING STATUS',
        text: 'Are you sure you want to change the showing status back to NEW SHOWING?',
        html: true,
        type: 'warning',
        confirmButtonColor: '#EB1F1F',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        closeButtonText: 'Cancel',
        closeOnConfirm: true,
      },
      overrideStatus => {
        if (overrideStatus) {
          const appointmentOverrideStatus = new AppointmentOverrideStatus({
            appointmentId: $routeParams.appointmentId,
            actionTaken: 'Status was overridden to new',
          });
          appointmentOverrideStatus.$save(() => {
            init();
          });
          return swal.close();
        }
        return swal.close();
      },
    );
  };
  vm.showAdminNote = () => {
    vm.action.type = 'notes';
  };

  vm.getAccessLabel = () => {
    switch (vm.appointmentConfig.access) {
      case 'SentriLock':
        return 'SentriLock 1-Day Code';
      case 'SentriLockV2':
        return 'SentriLock';
      case 'Lock Box':
        return 'Combination Lock Box';
      case 'MasterLock':
        return 'Master Lock';
      default:
        return vm.appointmentConfig.access;
    }
  };

  vm.getSuggestParams = () => '?redirectTo=listingCalendar';

  vm.appointmentHasNonAgentNotificationFeature = () =>
    featureEnabled('nonAgentNotificationFeature');

  vm.isNonAdminListingAgent = () => {
    const isAgentRole = vm.auth.role === 'AGENT';
    const isListingAgent = vm.listing.repsObjectIds.includes(vm.auth.id);
    return isAgentRole && isListingAgent;
  };

  vm.canAgentAction = action => {
    if (vm.auth.role !== 'AGENT') return true;
    const actionMap = {
      confirm: 'canConfirmAppts',
      deny: 'canDenyAppts',
      cancel: 'canDenyAppts',
    };
    const agent = vm.appointmentConfig.contacts.find(
      contact => contact.contactId === vm.auth.id,
    );

    return agent?.[actionMap[action]];
  };

  $rootScope.$watch('labelOverrideMap', () => {
    vm.relabelListingAvailability = availability =>
      $rootScope.labelOverrideMap[parseLabelFromString(availability)]?.label ||
      availability;
  });
}
